import React from 'react'

export default ({ inTime, limitTime, outTime }) => (
  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-4">
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {/* Start Time */}
      <div className="text-center md:text-left">
        <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
          Start Time
        </div>
        <div className="text-xl font-bold text-gray-900">{inTime || '-'}</div>
      </div>

      {/* End Time */}
      <div className="text-center md:text-left">
        <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
          End Time
        </div>
        <div className="text-xl font-bold text-gray-900">
          {limitTime || '-'}
        </div>
      </div>

      {/* Out Time */}
      <div className="text-center md:text-left">
        <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
          Out Time
        </div>
        <div className="text-xl font-bold text-gray-900">{outTime || '-'}</div>
      </div>
    </div>
  </div>
)
